// استيراد مكون البطاقات
import AssessmentCards from "../features/AssessmentCards"; 
import { PageContainer } from "../utils/layouts";

const Home = () => {
  return (
    <PageContainer >
      {/* عرض قائمة التقييمات (البطاقات) */}
      <AssessmentCards />
    </PageContainer>
  );
};

export default Home;